var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[{ active: _vm.init }, _vm.appBrand],attrs:{"id":"app"}},[(_vm.init)?_c('Sidebar'):_vm._e(),_c('div',{class:_vm.$route.path.replace(/\//g, ''),attrs:{"id":"view-wrapper"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }